import { createContext, useContext } from 'react';
import { applyTheme, storeTheme, type Theme } from './theme';

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);

/** Outside the provider (isolated component tests): acts on <html> directly, without re-rendering. */
const STANDALONE: ThemeContextValue = {
  get theme(): Theme {
    return typeof document !== 'undefined' && document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
  },
  setTheme(next: Theme) {
    storeTheme(next);
    applyTheme(next);
  },
  toggleTheme() {
    STANDALONE.setTheme(STANDALONE.theme === 'dark' ? 'light' : 'dark');
  },
};

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext) ?? STANDALONE;
}
